import React from 'react';
import CompanyMappingIdeasListItem from '../CompanyMappingIdeasListItem';

export default function CompanyMappingIdeasList({ ideas = [], onViewDetail }) {
    if (ideas.length === 0) {
        return (
            <div className="text-center py-12 text-black/50">
                <p className="text-lg mb-2">Nessuna idea ancora</p>
                <p className="text-sm">Usa la chat per generare idee o aggiungile manualmente</p>
            </div>
        );
    }

    return (
        <div className="overflow-x-auto">
            <table className="w-full">
                <thead>
                    <tr className="border-b border-black/10">
                        <th className="text-left py-3 px-4 text-xs font-semibold text-black/50 uppercase tracking-wider">
                            Idea
                        </th>
                        <th className="text-left py-3 px-4 text-xs font-semibold text-black/50 uppercase tracking-wider">
                            Categoria
                        </th>
                        <th className="text-center py-3 px-4 text-xs font-semibold text-black/50 uppercase tracking-wider">
                            Impatto (Y)
                        </th>
                        <th className="text-center py-3 px-4 text-xs font-semibold text-black/50 uppercase tracking-wider">
                            Facilità (X)
                        </th>
                        <th className="text-center py-3 px-4 text-xs font-semibold text-black/50 uppercase tracking-wider">
                            Azioni
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {ideas.map((idea) => (
                        <CompanyMappingIdeasListItem
                            key={idea._id || idea.id}
                            idea={idea}
                            onViewDetail={onViewDetail}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
}
